/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


setTimeout(function () {
    jQuery('.email-address').attr('aria-label', 'Email Address, info@anniebs.com');
}, 1000);
